<template>
  <v-btn flat type="submit" color="success" @click="getExcelReport">
    <strong>XLS</strong>
  </v-btn>
</template>

<script>
import XLSX from 'xlsx'
import moment from 'moment'
import download from 'downloadjs'
import _ from 'lodash'
import SubscriptionsService from '../services/SubscriptionsService'
import TransactionService from '../services/TransactionsService'
import Bugsnag from '../services/Bugsnag'

export default {
  name: 'ExportToExcel',
  components: {
    XLSX
  },
  data: () => ({
    items: []
  }),

  methods: {
    generateReport (data) {
      let workbook = XLSX.utils.book_new()
      workbook.props = {
        Title: 'Zlick Report',
        Author: 'Zlick',
        createdAt: moment().format('DD.MM.YYYY')
      }
      workbook.SheetNames.push('report')
      let worksheet = XLSX.utils.json_to_sheet(data)
      workbook.Sheets['report'] = worksheet
      let workbookOut = XLSX.write(workbook, {bookType: 'xlsx', type: 'binary'})
      download(workbookOut, 'report.xlsx')
    },
    formatProductDataForName (productData, fieldName, fieldName2 = undefined) {
      if (!productData) return ''
      try {
        if (productData[fieldName]) {
          return productData[fieldName]
        }
        if (fieldName2 && productData[fieldName2]) {
          return productData[fieldName2]
        }
        // old array format
        if (Array.isArray(productData)) {
          return productData.map(x => x[fieldName]).toString()
        }
        // new object format
        if (productData.product) {
          const filedMap = {
            periodLenght: 'periodLength'
          }
          const field = filedMap[fieldName]
          return productData.product.purchaseItems.map(x => x[field]).toString()
        }
        return ''
      } catch (error) {
        Bugsnag.send(error)
        return ''
      }
    },

    formatSubscriptionData (data) {
      let formatedJsonArray = _.map(data, _.clone)
      return formatedJsonArray.map((object) => {
        let amount
        if (object.amount) {
          amount = object.amount / 100
        } else if (object.productData && object.productData.pricing) {
          amount = object.productData.pricing[0].price / 100
        }
        return {
          CreatedAt: moment(object.createdAt).format('DD.MM.YYYY'),
          SubscriptionExpiresAt: moment(object.subscriptionExpiresAt).format('DD.MM.YYYY'),
          ProductName: object.productName || (object.productData && object.productData.name),
          Phone: object.phone,
          Email: object.email,
          Amount: amount,
          Name: object.name,
          PaymentType: object.paymentType,
          ClientUserId: object.clientUserId,
          State: object.state
        }
      })
    },

    formatTransactionData (data) {
      let formatedJsonArray = _.map(data, _.clone)
      return formatedJsonArray.map((object) => ({
        TransactionId: object._id,
        ClientTransactionId: object.clientTransactionId,
        CreatedAt: moment(object.createdAt).format('DD.MM.YYYY'),
        Phone: object.phone,
        ProductName: this.formatProductDataForName(object.productData, 'referenceName', 'name'),
        Content: object.content,
        ProductData: this.formatProductData(object.productData),
        Type: object.type,
        PeriodLenght: null,
        Amount: object.amount / 100,
        Agent: this.formatAgent(object.agent),
        clientUserId: object.clientUserId,
        RefundReason: object.refundReason
      }))
    },

    formatProductData (productData) {
      let productReferenceArray = []
      if (Array.isArray(productData) && productData[0]) {
        productData.forEach((productData) => {
          productReferenceArray.push(productData.referenceNumber)
        })
        return productReferenceArray.toString()
      }
      return null
    },

    formatAgent (agent) {
      if (!agent) return ''
      const agentName = agent.name.charAt(0).toUpperCase() + agent.name.slice(1)
      if (agent.familyName) return agentName + ' ' + agent.familyName
      return agentName
    },

    async getExcelReport () {
      let collectionType = this.$route.name.toLowerCase()
      let collection = await this.getCollection(collectionType)
      let formatedData
      if (collectionType === 'transactions') {
        formatedData = this.formatTransactionData(collection)
      } else if (collectionType === 'subscriptions') {
        formatedData = this.formatSubscriptionData(collection)
      } else {
        console.error('unknown collection')
      }
      this.generateReport(formatedData)
    },

    async getCollection (collectionType) {
      let searchValue = this.$store.state.searchValue
      let dateRange = this.$store.state.dateRange
      let total = this.$store.state[collectionType].total
      if (!searchValue && this.objectIsEmpty(dateRange)) {
        if (total < 21) {
          return this.collectionFromStorage(collectionType)
        }
        return this.getCollectionFromRecent(collectionType)
      } else {
        if (total < 21) {
          return this.collectionFromStorage(collectionType)
        }
        let searchQuery = {
          searchValue,
          dates: {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate
          }
        }
        return this.getCollectionFromSearch(collectionType, searchQuery, total)
      }
    },

    async collectionFromStorage (collectionType) {
      if (collectionType === 'transactions') {
        return this.$store.state.transactions.docs
      } else if (collectionType === 'subscriptions') {
        return this.$store.state.subscriptions.docs
      } else {
        console.error('unknown collection')
      }
    },

    async getCollectionFromRecent (collectionType) {
      let page = 1
      let limit = 2000
      if (collectionType === 'transactions') {
        let response = await TransactionService.search({page, limit}) // all could possibly be huge request, limiting to 100
        return response.data.docs
      } else if (collectionType === 'subscriptions') {
        let response = await SubscriptionsService.search({page, limit}) // all could possibly be huge request, limiting to 100
        return response.data.docs
      } else {
        console.error('unknown collection')
      }
    },

    async getCollectionFromSearch (collectionType, searchQuery, total) {
      let page = 1
      if (collectionType === 'transactions') {
        let response = await TransactionService.search({searchQuery, page, limit: total})
        return response.data.docs
      } else if (collectionType === 'subscriptions') {
        let response = await SubscriptionsService.search({searchQuery, page, limit: total})
        return response.data.docs
      } else {
        console.error('unknown collection')
      }
    },

    objectIsEmpty (object) {
      return Object.keys(object).length === 0 && object.constructor === Object
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExportToExcel.vue